export const SPECS = {
  CartTooltipWithoutNumber: 'specs.stores.CartTooltipWithoutNumber',
  CartOOIThunderboltCSSOptimization: 'specs.stores.CartOOIThunderboltCSSOptimization',
  fixEmailNotifierInCart: 'specs.stores.fixEmailNotifierInCart',
  ShouldUseSideCart: 'specs.stores.ShouldUseSideCart',
  ShouldUseOpenSideCartApiInAddToCart: 'specs.stores.ShouldUseOpenSideCartApiInAddToCart',
  ShouldUseEcomPlatformPublicApiAddToCartInPP: 'specs.stores.ShouldUseEcomPlatformPublicApiAddToCartInPP',
  MakeCartItemNameLink: 'specs.stores.MakeCartItemNameLink',
  AddSidePaddingOnCartPageForDesktopViewer: 'specs.stores.AddSidePaddingOnCartPageForDesktopViewer',
  AddSlotToCartPage: 'specs.stores.AddSlotToCartPage',
  NavigateToCartWhenDontShowSideCartOnMobile: 'specs.stores.NavigateToCartWhenDontShowSideCartOnMobile',
  ExpressCheckoutInSideCart: 'specs.stores.ExpressCheckoutInSideCart',
  ShowCssPerBreakpointIndicationsSideCart: 'specs.stores.ShowCssPerBreakpointIndicationsSideCart',
  SupportDeliveryViolationOnCart: 'specs.stores.SupportDeliveryViolationOnCart',
  UseAllStylesInCart: 'specs.stores.UseAllStylesInCart',
  UseGetSettingsWithDefaults: 'specs.stores.UseGetSettingsWithDefaults',
  SideCartElementsVisibilityInCss: 'specs.stores.SideCartElementsVisibilityInCss',
  CheckoutFromSDKInExpressCheckoutButtons: 'specs.stores.CheckoutFromSDKInExpressCheckoutButtons',
  ActionsDirectlyFromCurrentCartService: 'specs.stores.ActionsDirectlyFromCurrentCartService',
  CartFromSDKWhenShowShippingOrShowTax: 'specs.stores.CartFromSDKWhenShowShippingOrShowTax',
  UsePhotoMediaType: 'specs.stores.UsePhotoMediaType',
  UseCouponCodeOnSummary: 'specs.stores.UseCouponCodeOnSummary',
  CallEstimateTotalsWithShippingOnNavigate: 'specs.stores.CallEstimateTotalsWithShippingOnNavigate',
  UseCurrentCartFromSdk: 'specs.stores.UseCurrentCartFromSdk',
  ShouldPreloadPurchaseFlowProperties: 'specs.stores.ShouldPreloadPurchaseFlowProperties',
  WaitForPaymentMethodInit: 'specs.stores.WaitForPaymentMethodInit',
  ShouldNotUseDestinationCompleteness: 'specs.stores.ShouldNotUseDestinationCompleteness',
  MapCartSummaryColors: 'specs.stores.MapCartSummaryColors',
  CommonExpressForCart: 'specs.stores.CommonExpressForCart',
} as const;
